import React, { useEffect, useState, useMemo } from 'react';
import { CommonUtil } from "../../utils/CommonUtil";
import SingleSelectComp from "../../Components/SingleSelectComp";
import { NetworkManager } from "../../Components/NetworkManager";
import AGGrid from "../../Components/AGGrid";
import ReservationDetailsCellRenderer from "../Organization/ReservationDetailsCellRenderer";
import EquipCellRenderer from "../Organization/EquipCellRenderer";
import { Events } from "../Languages/Events";
import DetectDevice from '../../utils/DetectDevice';
import MGrid from '../../Components/MGrid';
import { Constants } from "../Languages/Constants";
import Loader from "../../Components/Loader";

const defObj = { key: '', value: 'All' };

const ReservationReport = () => {
    const { isMobile } = DetectDevice();
    const [orgData, setOrgData] = useState<any>(null);
    const [isCompanyVisible, setCompanyVisible] = useState(CommonUtil.isRootUser());
    const [selCompanyObj, setSelCompanyObj] = useState<any>({ orgId: null, orgName: "All" });
    const [reservationList, setReservationList] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [reserveObj, setReservationObj] = useState<any>(defObj);
    const [reservationCode, setReservationCode] = useState("");

    const [filters, setFilters] = useState({
        isUpcoming: true,
        isProgress: true,
        isActivationDue: true,
        isDeActivationDue: true,
        isDeleted: false,
        isDone: false
    });

    const reservationsColumns = useMemo(() => [
        { field: 'reservationStatus', headerName: CommonUtil.getMessageText(Constants.STATUS, "Status"), resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'reservationCode', headerName: CommonUtil.getMessageText(Constants.RESERVATION_ID, "Reservation Id"), resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter', cellRenderer: ReservationDetailsCellRenderer },
        { field: 'rentalDaysUnit', headerName: "Rental Days Unit", resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'rentalDaysRate', headerName: "Rental Days Rate", resizable: true, width: 200, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'distanceRate', headerName: CommonUtil.getMessageText(Constants.DISTANCE_RATE, "Distance Rate"), resizable: true, width: 200, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'distanceEstimate', headerName: "Distance Estimate", resizable: true, width: 200, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'engineHoursRate', headerName: "Engine Hours Rate", resizable: true, width: 200, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'engineHoursEstimate', headerName: "Engine Hours Estimate", resizable: true, width: 200, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'liabilityInsuranceRate', headerName: "Liability Insurance Rate", resizable: true, width: 200, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'liabilityChecked', headerName: "Liability Checked", resizable: true, width: 180, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'physicalDamageInsuranceRate', headerName: "Physical Damage Insurance Rate", resizable: true, width: 220, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'physicalDamageChecked', headerName: "Physical Damage Checked", resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'serviceFeeRate', headerName: "Service Fee Rate", resizable: true, width: 200, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'province', headerName: "Province", resizable: true, width: 150, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'tinyUrl', headerName: "Tiny URL", resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'UnitEquipName', headerName: CommonUtil.getMessageText(Constants.EQUIP_NO_NAME, "Equipment Number / Name"), resizable: true, width: 250, sortable: true, filter: 'agTextColumnFilter', cellRenderer: EquipCellRenderer },
        { field: 'equipmentType', headerName: CommonUtil.getMessageText(Constants.EQUIP_TYPE, "Equipment Type"), resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'brand', headerName: CommonUtil.getMessageText(Constants.BRAND, "Brand"), resizable: true, width: 100, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'year', headerName: CommonUtil.getMessageText(Constants.YEAR, "Year"), resizable: true, width: 100, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'reservationType', headerName: CommonUtil.getMessageText(Constants.RESERVATION_TYPE, "Reservation Type"), resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'VIN', headerName: CommonUtil.getMessageText(Constants.VIN, "VIN"), resizable: true, width: 100, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'driverName', headerName: CommonUtil.getMessageText(Constants.DRIVER, "Driver"), resizable: true, width: 100, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'renterName', headerName: CommonUtil.getMessageText(Constants.RESERVATIONS_MADE_BY, "Reservation made by"), resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'scheduledStartDate', headerName: CommonUtil.getMessageText(Constants.RESERVATIONS_START_DATE, "Reservation Start Date"), resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'scheduledEndDate', headerName: CommonUtil.getMessageText(Constants.RESERVATION_END_DATE, "Reservation End Date"), resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'isGeneric', headerName: CommonUtil.getMessageText(Constants.IS_GENERIC, "Is Generic"), resizable: true, width: 250, sortable: true, hide: true, filter: 'agNumberColumnFilter' },
        { field: 'policyNameLiability', headerName: CommonUtil.getMessageText(Constants.LIABILITY_PLAN, "Liability Plan"), resizable: true, width: 200, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'insurancePerDayAmountLiability', headerName: CommonUtil.getMessageText(Constants.LIABILITY_INSURANCE_PLAN_PER_DAY, "Liability Insurance Per Day"), resizable: true, width: 250, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'liabilityPaidBy', headerName: CommonUtil.getMessageText(Constants.LIABILITY_PLAN_PAID_BY, "Liability Insurance Paid By"), resizable: true, width: 250, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'policyNamePhysical', headerName: CommonUtil.getMessageText(Constants.PHYSICAL_DAMAGE_PLAN, "Physical Damage Plan"), resizable: true, width: 200, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'insurancePerDayAmountPhysical', headerName: CommonUtil.getMessageText(Constants.PHYSICAL_DAMAGE_PLAN_PER_DAY, "Damage Insurance Per Day"), resizable: true, width: 250, sortable: true, filter: 'agNumberColumnFilter' },
        { field: 'damageInsurancePaidBy', headerName: CommonUtil.getMessageText(Constants.PHYSICAL_DAMAGE_PLAN_PAID_BY, "Damage Insurance Paid By"), resizable: true, width: 250, sortable: true, filter: 'agNumberColumnFilter' }
    ], []);

    const onCompanyChange = (dataObj: any) => {
        setSelCompanyObj(dataObj);
    };

    const onStatusChange = (dataObj: any) => {
        if (dataObj) {
            setReservationObj(dataObj);
        } else {
            setReservationObj(defObj);
        }
    };

    const onReservationCodeChange = (e: any): void => {
        setReservationCode(e.currentTarget.value);
    };

    const onSuccessOffers = (dataObj: any) => {
        setIsLoading(false);
        let equips: any[] = [];
        if (dataObj) {
            const restData = CommonUtil.parseData(dataObj);
            if (restData) {
                if (Array.isArray(restData)) {
                    equips = restData;
                } else {
                    equips.push(restData);
                }
                equips.forEach((item: any) => {
                    if (item.isGeneric) {
                        item.isGeneric = item.isEquipmentGeneric === "Y" ? CommonUtil.EQUIP_GENERIC : CommonUtil.EQUIP_SPECIFIC;
                        if (item.isEquipmentGeneric === "Y" && item.isEnableAnyAvailble === "Y") {
                            item.isGeneric = item.isGeneric + " - " + CommonUtil.ANY_AVAILABLE;
                        }
                    }
                    item.UnitEquipName = (item.unitNumber ? item.unitNumber : item.genericEquipmentName);

                    if (item.isInsurancePaidByRenterLiability === "Y") {
                        item.liabilityPaidBy = CommonUtil.RENTER;
                    } else if (item.isInsurancePaidByOwnerLiability === "Y") {
                        item.liabilityPaidBy = CommonUtil.OWNER;
                    }

                    if (item.isInsurancePaidByRenterPhysical === "Y") {
                        item.damageInsurancePaidBy = CommonUtil.RENTER;
                    } else if (item.isInsurancePaidByOwnerPhysical === "Y") {
                        item.damageInsurancePaidBy = CommonUtil.OWNER;
                    }
                });

                setReservationList(equips);
            }
        }
    };

    const onFailOffers = (data: any) => {
        setIsLoading(false);
        console.log(data.errorMessage);
    };

    const toggleFilter = (filterName: keyof typeof filters) => {
        setFilters(prev => ({ ...prev, [filterName]: !prev[filterName] }));
    };

    const getButtonStyle = (isActive: boolean) => {
        const baseStyle: React.CSSProperties = {
            border: '1px solid #e4e4e4',
            borderRadius: '15px',
            marginTop: '5px',
            color: 'black',
            boxShadow: '1px 2px #e4e4e4'
        };

        if (isActive) {
            return {
                ...baseStyle,
                background: '#23D2C1',
                boxShadow: 'none'
            };
        } else {
            return {
                ...baseStyle,
                background: 'white',
                boxShadow: '1px 2px #e4e4e4'
            };
        }
    };

    const getAllReservations = () => {
        let qParam = selCompanyObj?.orgId ? selCompanyObj.orgId : "";
        if (CommonUtil.isRootUser()) {
            qParam = selCompanyObj?.orgId ? selCompanyObj.orgId : "";
        } else {
            qParam = CommonUtil.getSaasOrgId();
        }
        
        const usrUrl = "api/reservation/all";
        let statusList: string[] = [];

        if (filters.isUpcoming) statusList.push("Upcoming");
        if (filters.isProgress) statusList.push("In progress");
        if (filters.isActivationDue) statusList.push("Activation Due");
        if (filters.isDone) statusList.push("Done");
        if (filters.isDeleted) statusList.push("Deleted");
        if (filters.isDeActivationDue) statusList.push("Deactivation Due");

        if(statusList.length === 0){
            statusList.push("empty");
        }

        let payload: any = { isAll: qParam ? false : true, companyId: qParam, reservationCode: String(reservationCode).trim(), multipleStatus: statusList };
        if (qParam === "") delete payload.companyId;
        
        setIsLoading(true);
        NetworkManager.sendJsonRequest(usrUrl, payload, '', "POST", true, onSuccessOffers, onFailOffers);
    };

    const onClickDetail = (data: any) => {
        // Handle detail click
    };

    useEffect(() => {
        CommonUtil.SCREEN_NAME = CommonUtil.OWNER_RESERVATION;
        document.addEventListener(Events.SWITCH_CUSTOMER_EVENT, onSwitchCustomer);
        
        getAllReservations();

        CommonUtil.getAllAssetTypes((data: any) => {
            CommonUtil.ASSET_TYPES = data;
        });

        if (CommonUtil.isRootUser()) {
            CommonUtil.getAllOrgs((data: any) => {
                let arr = [{ orgId: null, orgName: "All" }];
                setOrgData([...arr, ...data]);
            });
        }

        return () => {
            document.removeEventListener(Events.SWITCH_CUSTOMER_EVENT, onSwitchCustomer);
        };
    }, []);

    useEffect(() => {
        getAllReservations();
    }, [filters, selCompanyObj]);

    const onSwitchCustomer = () => {
        setCompanyVisible(CommonUtil.isRootUser());
        if (CommonUtil.isRootUser()) {
            CommonUtil.getAllOrgs((data: any) => {
                let arr = [{ orgId: null, orgName: "All" }];
                setOrgData([...arr, ...data]);
            });
            setSelCompanyObj(null);
        } else {
            getAllReservations();
        }
        Events.dispatchBreadCrumbEvent();
    };

    return (
        <>
            {isLoading && <Loader />}
            <div className={'container-fluid'} style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                <div className="row">
                    <div className="col-md-2 col-12 pt-2" style={{ paddingLeft: '5px', zIndex: 999, display: (isCompanyVisible ? "" : "none") }}>
                        <span className="black-text css-16ihq8s">{CommonUtil.getMessageText(Constants.COMPANY, "Company")}</span>
                        <SingleSelectComp dataSource={orgData} selectedValue={selCompanyObj}
                            width={'100%'} handleChange={onCompanyChange}
                            value={'orgId'} label={'orgName'} />
                    </div>
                    <div className="col-md-2 col-6 pt-1" style={{ zIndex: '98', display: "none" }}>
                        <span className="black-text css-16ihq8s">{CommonUtil.getMessageText(Constants.STATUS, "Status")}</span>
                        <SingleSelectComp dataSource={CommonUtil.RESERVATION_STATUSES} selectedValue={reserveObj}
                            handleChange={onStatusChange} width={'100%'} value={'key'} label={'value'} />
                    </div>

                    <div className="col-md-2 col-6 pt-2" style={{ zIndex: '97' }}>
                        <span className="black-text css-16ihq8s">Reservation Code</span>
                        <input type="text" className="form-control "
                            required={true} placeholder="Reservation Code"
                            value={reservationCode} onChange={(e) => {
                                onReservationCodeChange(e);
                            }} />
                    </div>

                    <div className="col-md-12 col-lg-1 row">
                        <div className="col-md-1" style={{ paddingTop: (isCompanyVisible ? "7px" : '7px') }}>
                            <span className="black-text css-16ihq8s" style={{ visibility: "hidden" }}> dsdd</span>
                            <button type="button" className="btn btn-warning cus-btn btn-sm button-height"
                                onClick={getAllReservations}>
                                {CommonUtil.getMessageText(Constants.SEARCH, "Search")}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="row" style={{ paddingTop: "15px" }}>
                    <button type="button" className="btn button-height" style={getButtonStyle(filters.isUpcoming)} onClick={() => toggleFilter('isUpcoming')}>
                        {"Upcoming"}
                    </button>
                    &nbsp;
                    <button type="button" className="btn button-height" style={getButtonStyle(filters.isActivationDue)} onClick={() => toggleFilter('isActivationDue')}>
                        {"Activation Due"}
                    </button>
                    &nbsp;
                    <button type="button" className="btn button-height" style={getButtonStyle(filters.isProgress)} onClick={() => toggleFilter('isProgress')}>
                        {"In progress"}
                    </button>
                    &nbsp;
                    <button type="button" className="btn button-height" style={{ ...getButtonStyle(filters.isDeActivationDue), width: "180px" }} onClick={() => toggleFilter('isDeActivationDue')}>
                        {"Deactivation Due"}
                    </button>
                    &nbsp;
                    <button type="button" className="btn button-height" style={getButtonStyle(filters.isDeleted)} onClick={() => toggleFilter('isDeleted')}>
                        {"Deleted"}
                    </button>
                    &nbsp;
                    <button type="button" className="btn button-height" style={getButtonStyle(filters.isDone)} onClick={() => toggleFilter('isDone')}>
                        {"Done"}
                    </button>
                </div>
                <div className={`row ${isMobile ? '' : 'pt-3'}`}>
                    {
                        isMobile ? (
                            <MGrid id="ownerReservationList" cols={reservationsColumns} rows={reservationList} pageSize={10}
                                addNew={false} tooltip={"Offers"}
                                headerHeight={35} rowHeight={40} method={{ onClickDetail }}
                                suppressRowClickSelection={true} />
                        ) : (
                            <div className="ag-theme-alpine gridHeight" style={{ height: (isCompanyVisible ? "calc(100vh - 240px)" : "calc(100vh - 210px)"), width: "100%" }}>
                                <AGGrid id="ownerReservationReportList" cols={reservationsColumns} rows={reservationList} pageSize={500}
                                    addNew={false} tooltip={"Offers"}
                                    headerHeight={35} rowHeight={40} method={{ onClickDetail }}
                                    suppressRowClickSelection={true} />
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    );
};

export default ReservationReport;
